export default __webpack_public_path__ + "static/media/illustrate-document-valid.bd8772bd.svg";